export default __webpack_public_path__ + "static/purple-8f866cf8fb16ef557e0d83fa83b0d739.svg";